var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header_wrap" }, [
      _c(
        "div",
        { staticStyle: { width: "60%" } },
        [
          _c(
            "el-steps",
            {
              staticStyle: { width: "100%" },
              attrs: { "align-center": "", active: 1 }
            },
            [
              _c("el-step", { attrs: { title: "空运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "增值服务" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "托运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "确认委托" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "委托完成" } })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "center_wrap" },
      [
        _c(
          "div",
          { staticClass: "wrap_l" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.feeList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "Item_list",
                  on: {
                    click: function($event) {
                      return _vm.getIndex(index)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function($event) {
                              return _vm.selectHandler(index)
                            }
                          },
                          model: {
                            value: item.checked,
                            callback: function($$v) {
                              _vm.$set(item, "checked", $$v)
                            },
                            expression: "item.checked"
                          }
                        },
                        [_vm._v(_vm._s(item.feeName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            color: "#999",
                            margin: "10px 0"
                          }
                        },
                        [
                          item.remark && item.checked
                            ? _c("span", [_vm._v(_vm._s(item.remark))])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.checked,
                          expression: "item.checked"
                        }
                      ],
                      staticStyle: { width: "100%" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            width: "100%",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "box-sizing": "border-box"
                              }
                            },
                            [
                              _c("span", {}, [_vm._v(_vm._s(item.priceDesc))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "15px" } },
                                [
                                  !_vm.checkType(item.feeCode)
                                    ? _c("el-input-number", {
                                        attrs: {
                                          size: "mini",
                                          min: 1,
                                          max: 9999
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.handleChange(item)
                                          }
                                        },
                                        model: {
                                          value: item.num,
                                          callback: function($$v) {
                                            _vm.$set(item, "num", $$v)
                                          },
                                          expression: "item.num"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkType(item.feeCode)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "changeElInput",
                                          staticStyle: {
                                            "border-radius": "5px",
                                            padding: "5px",
                                            border: "1px solid #eee",
                                            display: "inline-block"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "80px" },
                                              attrs: {
                                                size: "mini",
                                                placeholder: "请选择币种"
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.handleChange(),
                                                    _vm.getIndex(index)
                                                }
                                              },
                                              model: {
                                                value: item.currency,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "currency",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.currency"
                                              }
                                            },
                                            _vm._l(item.rateDTOS, function(
                                              rateDTOS,
                                              rateDTOSIndex
                                            ) {
                                              return _c("el-option", {
                                                key: rateDTOSIndex,
                                                attrs: {
                                                  label: rateDTOS.currencyTo,
                                                  value: rateDTOS.currencyTo
                                                }
                                              })
                                            }),
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            staticStyle: {
                                              display: "inline-block",
                                              "border-left": "1px solid #eee",
                                              width: "150px"
                                            },
                                            attrs: {
                                              placeholder: "请输入货值",
                                              size: "mini"
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.handleChange(),
                                                  _vm.getIndex(index)
                                              }
                                            },
                                            model: {
                                              value: item.num,
                                              callback: function($$v) {
                                                _vm.$set(item, "num", $$v)
                                              },
                                              expression: "item.num"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "box-sizing": "border-box" } },
                            [
                              _vm._v(
                                "\n                  预估费用：" +
                                  _vm._s(item.currency) +
                                  _vm._s(item.amount) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            color: "#999",
                            margin: "0px 0"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(item.feeName) +
                              "服务手续" +
                              _vm._s(item.amount2)
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.feeList.length == 0,
                    expression: "feeList.length == 0"
                  }
                ],
                staticStyle: { padding: "20px" }
              },
              [
                _c("el-alert", {
                  attrs: {
                    closable: false,
                    title: "该线路暂无增值服务",
                    type: "warning",
                    description: "该线路暂无增值服务，请点击下一步继续操作",
                    "show-icon": ""
                  }
                })
              ],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("feeDetail", {
          ref: "feeList",
          attrs: {
            auto_fixed: _vm.auto_fixed,
            allMoreFeeInfo: _vm.allMoreFeeInfo,
            transportFeeForAir: _vm.transportFeeForAir,
            pickFeeForAir: _vm.pickFeeForAir,
            sendFeeForAir: _vm.sendFeeForAir,
            currencyCollection: _vm.currencyCollection,
            calculatePrice: _vm.calculatePrice,
            feeList: _vm.feeList
          },
          on: { pathToback: _vm.pathToback, pathToNext: _vm.pathToNext }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "-webkit-flex", "align-items": "center" } },
      [
        _c("img", {
          attrs: { src: require("../../assets/style.png"), alt: "" }
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticStyle: {
              "font-size": "20px",
              "font-family": "PingFang SC",
              "font-weight": "500",
              color: "#333333",
              "margin-left": "10px"
            }
          },
          [_vm._v("\n          增值服务\n        ")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58bd8d01", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58bd8d01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/AirMoreService.vue
// module id = null
// module chunks = 